// Put your application javascript here
let mainBsToast;

document.addEventListener('DOMContentLoaded', function () {
  var toastElList = [].slice.call(document.querySelectorAll('.toast'))
  var toastList = toastElList.map(function (toastEl) {
    return new bootstrap.Toast(toastEl);
  });
  mainBsToast = toastList[0];


  if (document.getElementById('navbar-search')) {
    document.getElementById('navbar-search')
      .addEventListener('shown.bs.dropdown', function (event) {
        document.getElementById('searchInput').focus();
      });
  }
  initTooltip();

  const profileCarousel = document.querySelector('#profileCarousel');
  initializedProfileCarousel = new bootstrap.Carousel(profileCarousel, {
    interval: false,
    keyboard: false,
    slide: false,
    hover: false,
    wrap: false,
    pause: false,
    touch: false,
  });

  document.querySelectorAll('.dropdown-menu').forEach(function (element) {
    element.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    if (element.classList.contains('should-expand')) {
      new bootstrap.Dropdown(element.parentElement).show();
    }
  });

  document.querySelectorAll('[data-toggle="lightbox"]').forEach(function (element) {
    element.addEventListener('click', function (event) {
      event.preventDefault();
      $(element).ekkoLightbox();
    });
  });

  $(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });

  if (window.location.hash === '#open_cart') {
    new bootstrap.Dropdown(document.getElementById('dropdownCartButton')).show();
  }
});

var bus = new Vue();

const mainToast = new Vue({
  el: '#main-toast',
  name: 'Toast',
  data: {
    text: undefined,
  },
  mounted() {
    if (this.$el.classList.contains('contact-success')) {
      this.text = 'Votre message a bien été envoyé.'
    }
  },
  delimiters: ["<%", "%>"],
});


const topCart = new Vue({
  el: '#cart',
  name: 'Cart',
  delimiters: ["<%", "%>"],
  data: {
    cart: {
      item_count: 0,
      items: [],
    },
    dropdown: false,
  },
  created() {
    axios.get('/cart.js').then((response) => {
      this.cart = response.data;
    });
  },
  methods: {
    increaseQuantity(item) {
      this.changeQuantity(item, item.quantity + 1);
    },
    decreaseQuantity(item) {
      this.changeQuantity(item, item.quantity - 1);
    },
    changeQuantity(item, quantity) {
      const updates = { updates: {} };
      updates.updates[item.variant_id] = quantity;
      axios.post('/cart/update.js', updates).then((response) => {
        this.cart = response.data;
      });
    },
    imgSize(imgUrl, size) {
      if (imgUrl) {
        return imgUrl.replace(/(\/[a-zA-Z]+)(\.[a-zA-Z]+\?)/, "$1_" + size + "$2");
      }
    },
  },
});

const navbarSearch = new Vue({
  el: '#navbar-search',
  delimiters: ["<%", "%>"],
  name: 'Search',
  data: {
    query: '',
    searchOpened: false,
    albums: [],
    articles: [],
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    toggleSearch() {
      console.log('toto');
      this.searchOpened = !this.searchOpened;
    },
    performSearch(newVal) {
      axios.get('/search/suggest.json?resources[fields]=author,body,product_type,title&resources[type]=product,article&q=' + newVal).then((response) => {
        this.albums = response.data.resources.results.products;
        this.articles = response.data.resources.results.articles;
      });
    },
    goToAlbum(albumId) {
      document.querySelector('.album-' + albumId).parentElement.click();
    }
  },
  watch: {
    query: _.debounce(function (newVal) {
      if (newVal) {
        this.performSearch(newVal);
      } else {
        this.albums = [];
        this.articles = [];
      }
    }, 300),
  },
});

if (document.querySelector('#profileCarousel')) {
  var profileCarousel = new Vue({
    el: '#profileCarousel',
    name: 'ProfileContactForm',
    delimiters: ["<%", "%>"],
    data: {
      chosenType: 'project',
      products: [],
      chosenProduct: { title: '' },
      initialProducts: [],
      body: undefined,
    },
    created() {
      axios.get('/products.json?limit=5').then((response) => {
        this.initialProducts = response.data.products;
        this.products = response.data.products;
      });
    },
    components: {
      VSelect: VueSelect.VueSelect,
    },
    computed: {
      slideAfterType() {
        if (this.chosenType === 'project') {
          return 1;
        }
        return 2;
      },
      prevSlide() {
        if (this.chosenType === 'project') {
          return undefined;
        }
        return 0;
      },
      defaultBackBehavior() {
        if (this.chosenType === 'project') {
          return 'prev';
        }
        return false;
      }
    },
    methods: {
      fetchOptions(search, loading) {
        loading(true);
        if (search) {
          axios.get('/search/suggest.json?resources[type]=product&q=' + search).then((response) => {
            this.products = response.data.resources.results.products;
            loading(false);
          });
        } else {
          this.products = this.initialProducts;
          loading(false);
        }
      },
      submitForm() {
        const formData = new FormData();
        formData.append('form_type', 'contact');
        formData.append(
          'contact[email]',
          document.querySelector('input[name="contact[email]"]').value
        );
        formData.append(
          'contact[name]',
          document.querySelector('input[name="contact[name]"]').value
        );

        formData.append(
          'contact[type]',
          this.chosenType
        );

        formData.append(
          'contact[body]',
          this.body
        );

        if (this.chosenProduct.title) {
          formData.append('contact[product]', this.chosenProduct.title);
        }
        axios.post('/contact#contact_form', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
          initializedProfileCarousel.next();
          if (response.request.responseURL.indexOf('challenge') !== -1) {
            window.location.href = '/challenge#contact_form';
          }
        });
      }
    }
  });
}

const news = new Vue({
  el: '#news',
  delimiters: ['<%', '%>'],
  data() {
    return {
      newsHidden: false,
    };
  },
  methods: {
    hideNews() {
      this.newsHidden = true;
    },
  }
});